(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-simple"] && !Shopify.designMode) return;
  try {
    
  const customerVisited = localStorage.getItem('customerVisited');
  if (!customerVisited) {
    localStorage.setItem('customerVisited', 'true');

    const sectionsToHide = document.querySelectorAll('[data-section-visibility="returning_customer"]');
    if (sectionsToHide) {
      sectionsToHide.forEach((section) => {
        section.style.display = 'none';
      });
    }
  } else {
    // Customer has visited before
    const sectionsToHide = document.querySelectorAll('[data-section-visibility="new_customer"]');
    if (sectionsToHide) {
      sectionsToHide.forEach((section) => {
        section.style.display = 'none';
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
